import { gql } from "@apollo/client"

// mutation to update plan status
export const UPDATE_PLAN_STATUS = gql`
  mutation UpdatePlanStatus($planId: Int!, $comment: String, $status: String) {
    createStatusUpdate(
      input: {
        statusUpdate: { planId: $planId, comment: $comment, status: $status }
      }
    ) {
      success
      errors {
        field
        messages
      }
      statusUpdate {
        id
        comment
        status
        name
        role
        createdAt
        updatedAt
      }
    }
  }
`

// query to get plan status by id
export const GET_STATUS_UPDATE = gql`
  query GetStatusUpdate($id: ID!) {
    statusUpdate(id: $id) {
      id
      comment
      date
      name
      role
      status
    }
  }
`
// Example query for above
//  const { data: statusData } = useQuery(GET_STATUS_UPDATE, {
//   variables: {
//     id: document.body.dataset.planId
//   },
//   errorPolicy: "all",
//   onCompleted() {
//     // console.log("completed get")
//   },
//   onError(error) {
//     // console.log("error", error)
//   }
// })
